<template>
    <div>
        <div v-if="client != null" class="client">
            <div class="client--left">
                <div class="client--left--top">
                    <p class="client--left--name">
                        {{client.firstname}} {{client.lastname}}
                        <span v-if="isStaff">*{{$t("appointments.staff_label")}}*</span>
                    </p>
                    <p>{{$t('client_detail.measurement_date')}}: {{formatDateString(client.measurement_date)}}</p>
                    <p>{{$t('client_detail.bed_position')}}: {{$t('appointment_edit.label_'+ client.additional_info.bedside)}}</p>
                    <p>{{client.additional_info.street}} {{client.additional_info.number}}</p>
                    <p>{{client.additional_info.postal}} {{client.additional_info.city}}</p>
                    <p>{{client.email}}</p>
                    <p>{{client.additional_info.tel}}</p>
                    <p class="client--left--bday" v-if="birthday != null">
                        {{birthday}}
                    </p>
                    <span class="client--left--spacer"></span>

                    <p v-if="client.additional_info.size" class="client--left--info">
                        {{$t('generic.size')}}:
                        {{client.additional_info.size}}{{$t('generic.cm')}}
                    </p>
                    <p v-if="client.additional_info.sleep_position" class="client--left--info">
                        {{$t('generic.sleep_position')}}:
                        <span v-if="isSleepPosition(client.additional_info.sleep_position)">{{$t('appointment_edit.label_'+client.additional_info.sleep_position)}}</span>
                        <span v-else>{{client.additional_info.sleep_position}}</span>
                    </p>
                    <p v-if="client.additional_info.base" class="client--left--info">
                        {{$t('generic.base')}}:
                        <span v-if="isBaseLevel(client.additional_info.base)">{{$t('appointment_edit.label_'+client.additional_info.base)}}</span>
                        <span v-else>{{client.additional_info.base}}</span>
                    </p>
                    <p v-if="client.additional_info.extras" class="client--left--info">
                        {{extraLabels.join(', ')}}
                    </p>
                </div>

                <div class="client--left--bottom" v-if="!isStaff">
                    <div class="client--left--bottom--row">
                        <button class="btn-basic bordered btn-result" @click.prevent="mailResult">
                            {{$t('client_detail.mail_result')}}
                        </button>
                        <button class="btn-basic bordered btn-print" @click.prevent="printResult">
                            {{$t('client_detail.print_result')}}
                        </button>
                    </div>
                    <div class="client--left--bottom--row">
                        <button class="btn-basic bordered btn-measurement" @click.prevent="clickSchedule">
                            {{$t('appointment_schedule.reschedule')}}
                        </button>
                    </div>
                </div>
            </div>

            <!-- dna info -->
            <div class="client--right">
                <DNAView :client="client" />
            </div>
        </div>
    </div>
</template>

<script>
import DNAView from "@/components/dna/DNAView.vue";
import {formatDate, newDateFromString} from "@/utils/utils.js";
import {measurementStore} from "@/stores/measurement";

export default {
    name : "ClientFiche",
    props: {
        client: {
            type: Object
        }
    },
    components : {
        DNAView
    },
    data() {
        return {
            loadingAppointment: false
        };
    },

    computed: {
        result() {
            return this.client.measurement_result;
        },

        birthday() {
            if (!this.client.additional_info.bday) {
                return null;
            }

            const date = newDateFromString(this.client.additional_info.bday);
            if (isNaN(date)) {
                return null;
            }
            return formatDate(date);
        },

        extraLabels() {
            let labels = [];
            const extras = Object.keys(this.client.additional_info.extras);
            for (const extra of extras) {
                labels.push(this.$t("appointment_edit.label_" + extra));
            }
            return labels;
        },

        isStaff() {
            return this.client.additional_info.is_staff === true;
        }
    },

    methods: {
        async clickSchedule() {
            this.$router.push({name: "client-reschedule", params: {client: this.client, ergosleep_id: this.client.ergosleep_id}});
        },

        mailResult() {
            const ergosleep_id = this.client.ergosleep_id;
            this.$router.push({name: "client-email-detail", params: {ergosleep_id}});
        },

        printResult() {
            let locale = this.$i18n.locale;
            if (locale.length > 2) {
                locale = locale.substring(2);
            }

            measurementStore().printFiche(this.client, locale);

            //prevent spamming btn:
            this.printEnabled = false;
            setTimeout(() => {
                this.printEnabled = true;
            }, 1000);
        },

        isSleepPosition(position) {
            return ["back", "side", "stomach"].includes(position);
        },

        isBaseLevel(position) {
            return ["boxspring", "base", "other"].includes(position);
        },

        formatDateString(date) {
            if (date) {
                return formatDate(newDateFromString(date));
            }
            return "";
        }
    }
};
</script>

<style lang="scss" scoped>
    .client {
        display: flex;
        justify-content: space-between;

        &--left {
            padding-top : 2rem;
            width : 25%;
            font-size: 1.25em;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 65vh;

            &--bottom {
                &--row {
                    display: flex;
                    justify-content: space-between;

                    .btn-basic {
                        margin-top : .5rem;
                        width : 100%;
                        font-size: 1em;
                        padding : initial;
                    }
                }
            }

            p {
                margin-bottom: 0.5em;
            }

            &--spacer {
                display: inline-block;
                height: 1rem;
            }

            &--name {
                font-weight: bold;

                span {
                    font-size: 0.8em;
                    font-weight: normal;
                    text-transform: uppercase;
                }
            }
        }

        &--right {
            width : 70%;

            .c-dna-view {
                margin-top : -1rem;
            }
        }

        .btn-result {
            margin-right : 1rem;
        }
    }
</style>